module.exports = __webpack_public_path__ + "img/receive-task.cc591ea8.svg";